@switch (page()) {
  @case ('about') {
    <div class="wrapper about">
      <ion-row>
        <ion-col size-lg="4" size="12">
          <div class="h1">{{ title() }}</div>
          <div class="-btn-wrapper">
            <ion-button [routerLink]="['/submit-your-property']">List Property</ion-button>
            <ion-button fill="outline" [routerLink]="['/listings/rent']">Rent a Property</ion-button>
          </div>

          <div class="custom-navigation">
                <span class="custom-prev"
                      (click)="prevTestimonialSlide()">
                  <ion-icon name="arrow-back-outline"></ion-icon>
                </span>
            <span (click)="nextTestimonialSlide()" class="custom-next">
                  <ion-icon name="arrow-forward-outline"></ion-icon>
                </span>
          </div>
        </ion-col>
        <ion-col size-lg="8" size="12">
          <swiper-container [breakpoints]="breakpointsAbout"
                            #swiper2
                            loop="true"
                            slides-per-view="2.8" space-between="24">
            @for (x of items(); track x) {
              <swiper-slide>
                <div class="card" [class.white]="bgColor() === 'white'">
                  <h3>{{x?.en.title}}</h3>
                  <p>{{x?.en.text}}</p>
                </div>
              </swiper-slide>
            }
          </swiper-container>
        </ion-col>
      </ion-row>
    </div>

  }
  @default {
    <div class="wrapper">
      <swiper-container [breakpoints]="breakpoints"
                        loop="true"
                        slides-per-view="2.8"
                        init="false"
                        [id]="sliderId()"
                        space-between="24" #swiper>
        @for (x of items(); track x) {
          <swiper-slide>
            <div class="card" [class.white]="bgColor() === 'white'">
              <h3>{{x?.en.title}}</h3>
              <p>{{x?.en.text}}</p>
            </div>
          </swiper-slide>
        }
      </swiper-container>
      <div class="custom-navigation">
                <span class="custom-prev"
                      (click)="prevTestimonialSlide()">
                  <ion-icon name="arrow-back-outline"></ion-icon>
                </span>
        <span (click)="nextTestimonialSlide()" class="custom-next">
                  <ion-icon name="arrow-forward-outline"></ion-icon>
                </span>
      </div>
    </div>
  }
}
